// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"ad1a10def38389c497df","6980":"64a18723a3e835863eac"}[chunkId] + ".js";
};